<div class="modal-header">
  <h3 class="modal-title">{{ data?.title }}</h3>
  <button type="button" class="close closeModal" aria-label="Close" (click)="modal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p>{{ data?.msg }}</p>
  @if (data?.extra) {
    <span class="text-danger">{{ data?.extra }}</span>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary" (click)="modal.dismiss()">No</button>
  <button type="button" class="btn btn-sm btn-primary" (click)="modal.close()">{{ data?.yes }}</button>
</div>
